// Components
import StyledCard from '@/components/global-components/styled-card/StyledCard';
import InformationCard from '@/components/global-components/information-card/InformationCard';
import Button from '@/components/global-components/Button';
import ButtonWithDropDown from '@/components/global-components/ButtomDropdown';

// Node Modules
import { nanoid } from 'nanoid';
import React, { useState } from 'react';

// Themes
import theme from '@/themes/index';

const Program = ({
  content,
  isDesktop,
  flexDirection = {},
  alternatePosition = false,
  infoContainerStyle = {},
  showTitle,
}) => {
  const {
    cardContent,
  } = content;

  const getStyleCardContent = () => {
    return (
      <>
        <InformationCard content={content} showTitle={showTitle} />
        <div className='buttons-container'>
          {cardContent.buttons?.map(item => (
            <Button
              className={item.button.style.toLowerCase()}
              key={nanoid()}
              text={item.button.title}
              href={item.button.url}
              target={item.button.openInAnotherPage ? '_blank' : '_self'}
              variants={content.variants}
              styles={{
                width: isDesktop ? 'fit-content' : '100%',
                padding: '0 1rem',
              }}></Button>
          ))}
          {content.variants ? (
            <ButtonWithDropDown
              elements={getVariantData()}
              label={'Book now'} />
          ) : ''}
        </div>
        <style jsx>{`
          div.buttons-container {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 1rem;
            align-items: center;
          }

          @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
            div.buttons-container {
              flex-direction: row;
              gap: 2rem;
              justify-content: center;
            }
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            div.buttons-container {
              justify-content: left;
            }
          }
        `}</style>
      </>
    );
  };

  function getVariantData() {
    let elementsVar = []
    if (content.variants && content.variants.length > 0) {
      elementsVar = content.variants.map(el => {
        return {
          'text': el.variantName, 'subtext': el.variantSubtext, 'url': `/programs-online/${el.variantId}`, 'target': '_blank',
        }
      })
    }

    return elementsVar;
  }


  return (
    <>
      <div className='program-container'>
        <StyledCard
          content={content}
          imageStyles={{
            maxWidth: isDesktop ? '28.75rem' : '100%',
            maxHeight: isDesktop ? '25rem' : '100%',
          }}
          containerStyle={alternatePosition ? flexDirection : {
            flexDirection: isDesktop ? 'row-reverse' : 'column-reverse',
          }}
          infoContainerStyle={alternatePosition ?
            infoContainerStyle
            : {
              paddingRight: '0',
              paddingLeft: '0.5rem',
              flexDirection: 'column',
            }}>
          {getStyleCardContent()}
        </StyledCard>
      </div>
      <style jsx>{`
          div.program-container {
            display: flex;
            flex-direction: column;
          }
        `}</style>
      <style global jsx>{`
          div.program-container .container .info-container .card-content h5,
          h6,
          ul {
            padding-bottom: 1rem;
            margin-block-start: 0;
            margin-block-end: 0;
            margin-inline-start: 0;
            margin-inline-end: 0;
          }

          div.program-container .container .info-container .card-content h5 {
            font-size: 1.5rem;
            line-height: 1.575rem;
          }

          div.program-container .container .info-container .card-content h6 {
            font-size: 1.25rem;
            line-height: 1.225rem;
          }

          div.program-container .container .info-container .card-content p {
            margin: 0;
            padding-bottom: 1.5rem;
            text-align: center;
          }

          div.program-container .container .info-container .card-content ul {
            padding-inline-start: 1rem;
            text-align: left;
            font-family: ${theme.fontFamilies.openSans};
            font-size: 1rem;
            line-height: 1.2255rem;
          }

          div.program-container
            .container
            .info-container
            .card-content
            ul
            li
            p {
            padding: 0;
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            div.program-container .container .info-container .card-content p {
              padding-bottom: 2rem;
              text-align: justify;
            }

            div.program-container .container .info-container .card-content h5 {
              font-size: 2rem;
              line-height: 3rem;
            }

            div.program-container .container .info-container .card-content h6 {
              font-size: 1.5rem;
              line-height: 2.25rem;
            }

        

            div.program-container .container .info-container .card-content ul {
            font-size: 1.25rem;
            line-height: 1.875rem;
          }
          }
        `}</style>
    </>
  );
};

export default Program;
